var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M13.5 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M15 8A7 7 0 1 1 1 8 7 7 0 0 1 15 8M7.2 4h1.6v1.577H7.2zm0 3h1.6v5H7.2V7","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }